module.exports = __webpack_public_path__ + "img/gp.dc807bdc.svg";